function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var Gt = Object.defineProperty;
var Ft = (e, t, s) => t in e ? Gt(e, t, {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: s
}) : e[t] = s;
var Y = (e, t, s) => (Ft(e, typeof t != "symbol" ? t + "" : t, s), s),
  Pt = (e, t, s) => {
    if (!t.has(e)) throw TypeError("Cannot " + s);
  };
var S = (e, t, s) => {
  if (t.has(e)) throw TypeError("Cannot add the same private member more than once");
  t instanceof WeakSet ? t.add(e) : t.set(e, s);
};
var b = (e, t, s) => (Pt(e, t, "access private method"), s);
const yt = e => {
    if (!e || typeof e != "object") return !1;
    const t = Object.getPrototypeOf(e);
    return t === Object.prototype || t === null;
  },
  vt = e => typeof e == "function",
  W = e => !isNaN(Number(e)),
  rt = e => e == null,
  lt = e => e instanceof HTMLElement ? e : document.querySelector(e),
  ct = (e, t) => t ? e.closest(`.${t}`) : null,
  R = e => "touches" in e ? e.touches.length === 0 ? {
    clientX: 0,
    clientY: 0
  } : e.touches.length === 1 ? {
    clientX: e.touches[0].clientX,
    clientY: e.touches[0].clientY
  } : {
    clientX: [...e.touches].reduce((t, s) => t + s.clientX, 0) / e.touches.length,
    clientY: [...e.touches].reduce((t, s) => t + s.clientY, 0) / e.touches.length
  } : {
    clientX: e.clientX,
    clientY: e.clientY
  },
  y = e => {
    const _e$getBoundingClientR = e.getBoundingClientRect(),
      t = _e$getBoundingClientR.width,
      s = _e$getBoundingClientR.height,
      n = _e$getBoundingClientR.top,
      o = _e$getBoundingClientR.left,
      r = _e$getBoundingClientR.bottom;
    return {
      width: t,
      height: s,
      top: n,
      left: o,
      bottom: r
    };
  },
  Et = e => e.touches.length >= 2 ? Math.hypot(e.touches[0].clientX - e.touches[1].clientX, e.touches[0].clientY - e.touches[1].clientY) : 0,
  C = (e, t) => {
    for (const _ref of Object.entries(t)) {
      var _ref2 = _slicedToArray(_ref, 2);
      const s = _ref2[0];
      const n = _ref2[1];
      typeof n == "string" && e.style.setProperty(s, n);
    }
  },
  x = (e, t) => {
    for (const _ref3 of Object.entries(t)) {
      var _ref4 = _slicedToArray(_ref3, 2);
      const s = _ref4[0];
      const n = _ref4[1];
      e.setAttribute(s, n);
    }
  },
  E = (e, t) => {
    for (const _ref5 of Object.entries(t)) {
      var _ref6 = _slicedToArray(_ref5, 2);
      const s = _ref6[0];
      const n = _ref6[1];
      e[s] = n;
    }
  },
  w = (e, t, s) => Math.min(Math.max(e, t), s),
  X = e => isNaN(e) ? 0 : Math.round(e * 100) / 100,
  St = e => {
    throw new Error(e);
  },
  ht = e => console.warn(e),
  I = (e = "div", t, s, n) => {
    const o = document.createElement(e);
    return t && o.classList.add(...t.split(" ")), s && x(o, s), n && (o.innerHTML = n), o;
  },
  p = "zoomist",
  qt = `${p}-container`,
  bt = `${p}-wrapper`,
  ut = `${p}-image`,
  Kt = `${p}-not-draggable`,
  Jt = `${p}-not-wheelable`,
  $ = `${p}-slider`,
  Qt = `${p}-slider-wrapper`,
  te = `${p}-slider-bar`,
  ee = `${p}-slider-button`,
  Z = `${p}-zoomer`,
  se = `${p}-zoomer-button`,
  gt = `${p}-zoomer-icon`,
  mt = `${p}-zoomer-in`,
  dt = `${p}-zoomer-out`,
  ft = `${p}-zoomer-reset`,
  ne = `${p}-zoomer-disabled`,
  ie = {
    tabindex: "0",
    role: "slider",
    "aria-label": "slider for zoomist",
    "aria-valuemin": "0",
    "aria-valuemax": "100",
    "aria-valuenow": "0",
    "aria-disabled": "false"
  },
  _t = {
    tabindex: "0",
    role: "button",
    type: "button",
    "aria-disabled": "false"
  },
  oe = Object.assign({}, _t, {
    "aria-label": "button for zoom in zoomist"
  }),
  ae = Object.assign({}, _t, {
    "aria-label": "button for zoom out zoomist"
  }),
  re = Object.assign({}, _t, {
    "aria-label": "button for reset zoomist scale"
  }),
  le = typeof window < "u" && typeof window.document < "u",
  L = le && "ontouchstart" in window,
  ce = L ? "touchstart" : "mousedown",
  Tt = L ? "touchmove" : "mousemove",
  Ot = L ? "touchend" : "mouseup",
  he = "wheel",
  ue = ["left", "right", "center"],
  me = ["top", "bottom", "center"],
  Yt = "--scale",
  Xt = "--translate-x",
  Dt = "--translate-y",
  de = "--value",
  wt = {
    // set is draggable or not
    draggable: !0,
    // set is wheelable or not
    wheelable: !0,
    // set is pinchable or not
    pinchable: !0,
    // set image stuck on bounds
    bounds: !0,
    // the ratio of zooming at one time
    zoomRatio: 0.1,
    // the max scale of zoomist-image (must be number larger then initScale)
    maxScale: 10,
    // the min scale of zoomist-image (must be number smaller then initScale)
    minScale: 1,
    // set initial scale of zoomist-image
    initScale: null,
    // if set to true, enable to release touch events to allow for further page scrolling when .zoomist-image is on bounds.
    dragReleaseOnBounds: !1,
    // if set to true, enable to release wheel events to allow for further page scrolling when .zoomist-image is on mixScale or maxScale.
    wheelReleaseOnMinMax: !1,
    // elements matched this class will not be dragged.
    disableDraggingClass: Kt,
    // elements matched this class will not be zoomed by mouse wheel.
    disableWheelingClass: Jt,
    // if set to true, enable to smooth drag
    smooth: !1
  },
  fe = {
    // the css selector string or a element of the slider
    el: null,
    // the direction of the slider 'horizontal' or 'vertical'
    direction: "horizontal"
  },
  ge = {
    el: `.${$}`
  },
  _e = {
    el: null,
    // the css selector string or a element for in-zoomer
    inEl: null,
    // the css selector string or a element for out-zoomer
    outEl: null,
    // the css selector string or a element for reset-zoomer
    resetEl: null,
    // in zoomer and out zoomer will be disabled when image comes to maximin or minimum
    disabledClass: ne
  },
  pe = {
    el: `.${Z}`,
    inEl: `.${mt}`,
    outEl: `.${dt}`,
    resetEl: `.${ft}`
  },
  ve = {
    // invoked when zoomist instance ready
    ready: null,
    // invoked when reset methods be used
    reset: null,
    // invoked when image changes it's size
    resize: null,
    // invoked before destroy methods be used
    beforeDestroy: null,
    // invoked after destroy methods be used
    destroy: null,
    // invoked before update methods be used
    beforeUpdate: null,
    // invoked when update methods be used
    update: null,
    // invoked when image is zooming
    zoom: null,
    // invoked when wheeling
    wheel: null,
    // invoked when mousedown on wrapper
    dragStart: null,
    // invoked when dragging the image
    drag: null,
    // invoked when mouseup on wrapper
    dragEnd: null,
    // invoked when mousedown on wrapper
    pinchStart: null,
    // invoked when pinching the image
    pinch: null,
    // invoked when mouseup on wrapper
    pinchEnd: null,
    // invoked when mousedown on slider
    slideStart: null,
    // invoked when sliding the slider
    slide: null,
    // invoked when mouseup on slider
    slideEnd: null
  },
  Ee = {
    // slider options
    slider: null,
    // zoomer options
    zoomer: null
  },
  Se = `
<svg viewBox="0 0 12 12" class="${gt}">
  <polygon points="12,5.5 6.5,5.5 6.5,0 5.5,0 5.5,5.5 0,5.5 0,6.5 5.5,6.5 5.5,12 6.5,12 6.5,6.5 12,6.5 "/>
</svg>
`,
  be = `
<svg viewBox="0 0 12 12" class="${gt}">
  <rect y="5.5" width="12" height="1"/>
</svg>
`,
  Te = `
<svg viewBox="0 0 12 12" class="${gt}">
  <path d="m7.45,1.27l.35-.22c.26-.17.34-.52.17-.78-.17-.27-.52-.34-.78-.17l-1.54.99-.19.13-.11.46,1.12,1.75c.11.17.29.26.48.26.1,0,.21-.03.31-.09.26-.17.34-.52.17-.78l-.29-.46c1.85.5,3.22,2.17,3.22,4.18,0,2.39-1.95,4.34-4.34,4.34S1.66,8.92,1.66,6.52c0-1.15.44-2.23,1.25-3.05.22-.22.22-.58,0-.8-.22-.22-.58-.22-.8,0-1.02,1.03-1.58,2.4-1.58,3.85,0,3.02,2.46,5.48,5.48,5.48s5.48-2.46,5.48-5.48c0-2.51-1.71-4.62-4.02-5.26Z"/>
</svg>
`,
  Oe = {
    on(e, t) {
      if (!t || !vt(t)) return this;
      const s = this.__events__;
      return e.split(" ").forEach(n => {
        const o = n;
        s[o] || (s[o] = []), s[o].push(t);
      }), this;
    },
    emit(e, ...t) {
      const s = this.__events__;
      return s[e] ? (s[e].forEach(n => {
        vt(n) && n.apply(this, t);
      }), this) : this;
    },
    zoom(e, t) {
      const s = this.transform.scale,
        n = this.useFixedRatio(X(s * (e + 1)));
      return s === n ? this : (this.zoomTo(n, t), this);
    },
    zoomTo(e, t = !0) {
      const s = this.image,
        _this$transform = this.transform,
        n = _this$transform.scale,
        o = _this$transform.translateX,
        r = _this$transform.translateY,
        i = this.options.bounds;
      if (e = this.useFixedRatio(e), e === n) return this;
      if (this.transform.scale = e, !t) return this.emit("zoom", this, this.transform.scale), this;
      t = typeof t == "boolean" ? this.getContainerCenterClient() : t;
      const _t2 = t,
        l = _t2.clientX,
        h = _t2.clientY,
        _y = y(s),
        c = _y.top,
        f = _y.left,
        m = _y.width,
        a = _y.height,
        _this$getImageDiff = this.getImageDiff(),
        d = _this$getImageDiff.width,
        g = _this$getImageDiff.height,
        _ = e / n - 1,
        T = (m / 2 - l + f) * _ + o,
        u = (a / 2 - h + c) * _ + r,
        v = i ? w(T, d, -d) : T,
        O = i ? w(u, g, -g) : u;
      return E(this.transform, {
        translateX: v,
        translateY: O
      }), this.emit("zoom", this, this.transform.scale), this;
    },
    move(e) {
      const t = this.options.bounds,
        _this$transform2 = this.transform,
        s = _this$transform2.translateX,
        n = _this$transform2.translateY,
        o = e.x,
        r = e.y,
        _this$getImageDiff2 = this.getImageDiff(),
        i = _this$getImageDiff2.width,
        l = _this$getImageDiff2.height;
      if (W(o)) {
        const h = s + o,
          c = t ? w(h, i, -i) : h;
        this.transform.translateX = c;
      }
      if (W(r)) {
        const h = n + r,
          c = t ? w(h, l, -l) : h;
        this.transform.translateY = c;
      }
      return this;
    },
    moveTo(e) {
      const t = this.options.bounds,
        s = e.x,
        n = e.y,
        _this$getImageDiff3 = this.getImageDiff(),
        o = _this$getImageDiff3.width,
        r = _this$getImageDiff3.height;
      if (W(s)) {
        const i = Number(s),
          l = t ? w(i, o, -o) : i;
        this.transform.translateX = l;
      }
      if (W(n)) {
        const i = Number(n),
          l = t ? w(i, r, -r) : i;
        this.transform.translateY = l;
      }
      if (ue.some(i => i === s)) {
        const l = {
          left: -o,
          right: o,
          center: 0
        }[s];
        this.transform.translateX = l;
      }
      if (me.some(i => i === n)) {
        const l = {
          top: -r,
          bottom: r,
          center: 0
        }[n];
        this.transform.translateY = l;
      }
      return this;
    },
    slideTo(e) {
      const _this$options = this.options,
        t = _this$options.minScale,
        s = _this$options.maxScale,
        n = (s - t) * e / 100 + t;
      return this.zoomTo(n), this;
    },
    reset() {
      const e = this.options.initScale;
      return E(this.transform, {
        scale: e,
        translateX: 0,
        translateY: 0
      }), this.emit("reset", this), this;
    },
    destroy(e = !1) {
      const t = this.element,
        s = this.image,
        n = this.controller;
      return this.mounted && (this.emit("beforeDestroy", this), n.abort(), this.destroyModules(), e && s && (this.reset(), s.removeAttribute("style")), t[p] = null, this.mounted = !1, this.emit("destroy", this)), null;
    },
    update(e) {
      const t = this.element,
        s = this.controller;
      return this.emit("beforeUpdate", this), t[p] = null, this.mounted = !1, s.abort(), this.destroyModules(), e && (this.options = Object.assign({}, wt, yt(e) && e)), this.init(), this.emit("update", this), this;
    },
    getImageData() {
      return Object.assign({}, this.data.imageData);
    },
    getContainerData() {
      return Object.assign({}, this.data.containerData);
    },
    getSliderValue() {
      const e = this.__modules__.slider;
      return e && e.value !== void 0 ? e.value : null;
    },
    isOnBoundTop() {
      const e = this.options.bounds;
      if (!e) return !1;
      const t = this.transform.translateY,
        _this$getImageDiff4 = this.getImageDiff(),
        s = _this$getImageDiff4.height;
      return t * -1 === X(s);
    },
    isOnBoundBottom() {
      const e = this.options.bounds;
      if (!e) return !1;
      const t = this.transform.translateY,
        _this$getImageDiff5 = this.getImageDiff(),
        s = _this$getImageDiff5.height;
      return t === X(s);
    },
    isOnBoundLeft() {
      const e = this.options.bounds;
      if (!e) return !1;
      const t = this.transform.translateX,
        _this$getImageDiff6 = this.getImageDiff(),
        s = _this$getImageDiff6.width;
      return t * -1 === X(s);
    },
    isOnBoundRight() {
      const e = this.options.bounds;
      if (!e) return !1;
      const t = this.transform.translateX,
        _this$getImageDiff7 = this.getImageDiff(),
        s = _this$getImageDiff7.width;
      return t === X(s);
    },
    isOnBoundX() {
      const e = this.options.bounds;
      if (!e) return !1;
      const t = this.transform.translateX,
        _this$getImageDiff8 = this.getImageDiff(),
        s = _this$getImageDiff8.width;
      return Math.abs(t) === Math.abs(X(s));
    },
    isOnBoundY() {
      const e = this.options.bounds;
      if (!e) return !1;
      const t = this.transform.translateY,
        _this$getImageDiff9 = this.getImageDiff(),
        s = _this$getImageDiff9.height;
      return Math.abs(t) === Math.abs(X(s));
    },
    isOnMinScale() {
      const e = this.options.minScale,
        t = this.transform.scale;
      return t === e;
    },
    isOnMaxScale() {
      const e = this.options.maxScale,
        t = this.transform.scale;
      return t === e;
    },
    // private methods
    getImageDiff() {
      const _this$getContainerDat = this.getContainerData(),
        e = _this$getContainerDat.width,
        t = _this$getContainerDat.height,
        _this$getImageData = this.getImageData(),
        s = _this$getImageData.width,
        n = _this$getImageData.height;
      return {
        width: (e - s) / 2,
        height: (t - n) / 2
      };
    },
    // private methods
    getContainerCenterClient() {
      const e = this.element,
        _y2 = y(e),
        t = _y2.top,
        s = _y2.left,
        n = _y2.width,
        o = _y2.height;
      return {
        clientX: s + n / 2,
        clientY: t + o / 2
      };
    },
    // private methods
    getScaleRatio() {
      const e = this.transform.scale,
        _this$options2 = this.options,
        t = _this$options2.minScale,
        s = _this$options2.maxScale;
      return (e - t) / (s - t);
    },
    // private methods
    useFixedRatio(e) {
      const _this$options3 = this.options,
        t = _this$options3.minScale,
        s = _this$options3.maxScale;
      return w(e, t, s);
    },
    // private methods
    // animation
    useAnimate(e) {
      const t = this.options.smooth,
        s = this.transform,
        o = (1100 - (typeof t == "object" ? Math.max(0.1, Math.min(1, t.damping)) : 0.6) * 1e3) * 0.5,
        r = () => {
          if (!this.states.dragging && (Math.abs(e.velocityX) > 0.01 || Math.abs(e.velocityY) > 0.01)) {
            const i = Date.now(),
              l = i - e.lastTime,
              h = Math.exp(-l / o);
            e.velocityX *= h, e.velocityY *= h, e.lastTime = i;
            const c = e.velocityX * l,
              f = e.velocityY * l;
            if (this.moveTo({
              x: s.translateX + c,
              y: s.translateY + f
            }), Math.abs(e.velocityX) < 0.01 && Math.abs(e.velocityY) < 0.01) {
              e.frame = null;
              return;
            }
          }
          e.frame = requestAnimationFrame(r);
        };
      return r;
    }
  },
  H = Object.defineProperty;
var V, Rt, U, At, j, Lt, k, zt, G, Mt, F, Ct, P, It, q, xt, K, $t, J, Nt, Q, Bt, tt, Wt;
class Ye {
  constructor(t, s) {
    // create initial data
    S(this, V);
    // mount elements and bind events
    S(this, U);
    // resize, drag, pinch, wheel
    S(this, j);
    // on wheel
    S(this, k);
    // on drag (mouse)
    S(this, G);
    // on touch (pinch and touchmove)
    S(this, F);
    // resize observer on element
    S(this, P);
    // check modules and create
    S(this, q);
    // mount slider
    S(this, K);
    // slider events
    S(this, J);
    // mount zoomer
    S(this, Q);
    // zoomer event
    S(this, tt);
    Y(this, "element");
    Y(this, "options");
    Y(this, "wrapper");
    Y(this, "image");
    Y(this, "mounted");
    Y(this, "data");
    Y(this, "transform");
    Y(this, "states");
    Y(this, "controller");
    Y(this, "__events__");
    Y(this, "__modules__");
    if (!t) return St("The first argument is required.");
    const n = lt(t);
    if (!n) return St(`Element ${t} is not exist.`);
    this.element = n, this.options = Object.assign({}, wt, yt(s) && s), this.init();
  }
  // check zoomist-image is exist
  init() {
    const t = this.element,
      _this$options4 = this.options,
      s = _this$options4.bounds,
      n = _this$options4.minScale,
      o = _this$options4.maxScale,
      r = _this$options4.initScale;
    if (t[p]) return;
    t[p] = this;
    const i = t.querySelector(`.${bt}`),
      l = t.querySelector(`.${ut}`);
    if (!i) return ht(`${p} needs a ".${bt}" element.`);
    if (!l) return ht(`${p} needs a ".${ut}" element.`);
    this.options.minScale = s && n < 1 ? 1 : n, this.options.maxScale = Math.max(o, n), this.options.initScale = w(r || n, n, o), this.wrapper = i, this.image = l, b(this, V, Rt).call(this);
  }
  // destory modules
  destroyModules() {
    const _this$__modules__ = this.__modules__,
      t = _this$__modules__.slider,
      s = _this$__modules__.zoomer;
    t && this.destroySlider(), s && this.destroyZoomer();
  }
  // destroy slider
  destroySlider() {
    var r, i;
    const t = this.__modules__.slider;
    if (!t || !t.mounted) return;
    const s = t.options.el,
      n = t.controller;
    s === `.${$}` ? (r = t.sliderEl) == null || r.remove() : (i = t.sliderTrack) == null || i.remove(), n == null || n.abort(), t.mounted = !1;
  }
  // destroy zoomer
  destroyZoomer() {
    const t = this.__modules__.zoomer;
    if (!t || !t.mounted) return;
    const _t$options = t.options,
      s = _t$options.el,
      n = _t$options.inEl,
      o = _t$options.outEl,
      r = _t$options.resetEl,
      i = t.controller,
      l = t.zoomerEl,
      h = t.zoomerInEl,
      c = t.zoomerOutEl,
      f = t.zoomerResetEl,
      m = (a, d, g) => {
        a === `.${d}` && (g == null || g.remove());
      };
    [{
      target: s,
      className: Z,
      el: l
    }, {
      target: n,
      className: mt,
      el: h
    }, {
      target: o,
      className: dt,
      el: c
    }, {
      target: r,
      className: ft,
      el: f
    }].forEach(a => m(a.target, a.className, a.el)), i == null || i.abort(), t.mounted = !1;
  }
}
V = new WeakSet(), Rt = function () {
  const t = this.element,
    s = this.image,
    n = this.options,
    o = n.draggable,
    r = n.pinchable,
    i = t.offsetWidth,
    l = t.offsetHeight,
    h = s.offsetWidth,
    c = s.offsetHeight,
    _y3 = y(s),
    f = _y3.width,
    m = _y3.height;
  if (!h || !c) return ht(`The width or height of ${ut} should not be 0.`);
  if (this.transform = {
    scale: 0,
    translateX: 0,
    translateY: 0
  }, this.data = {
    imageData: {
      originWidth: h,
      originHeight: c,
      width: f,
      height: m
    },
    containerData: {
      width: i,
      height: l
    }
  }, L && (o || r) && (this.data.touchData = {
    hypot: 0,
    prevX: 0,
    prevY: 0,
    offsetX: 0,
    offsetY: 0,
    imageTop: 0,
    imageLeft: 0,
    widthDiff: 0,
    heightDiff: 0,
    lastTime: 0,
    velocityX: 0,
    velocityY: 0,
    frame: null
  }), !L && o && (this.data.dragData = {
    prevX: 0,
    prevY: 0,
    lastTime: 0,
    velocityX: 0,
    velocityY: 0,
    frame: null
  }), this.__events__ = Object.assign({}, ve), n.on) for (const _ref7 of Object.entries(n.on)) {
    var _ref8 = _slicedToArray(_ref7, 2);
    const a = _ref8[0];
    const d = _ref8[1];
    this.__events__[a] = [d];
  }
  if (this.__modules__ = Object.assign({}, Ee), n.slider) {
    const a = n.slider === !0 ? ge : n.slider;
    this.__modules__.slider = {
      options: Object.assign({}, fe, a)
    };
  }
  if (n.zoomer) {
    const a = n.zoomer === !0 ? pe : n.zoomer;
    this.__modules__.zoomer = {
      options: Object.assign({}, _e, a)
    };
  }
  this.controller = new AbortController(), b(this, U, At).call(this);
}, U = new WeakSet(), At = function () {
  if (this.mounted) return;
  const t = this.element,
    s = this.image,
    _this$options5 = this.options,
    n = _this$options5.minScale,
    o = _this$options5.maxScale,
    r = _this$options5.initScale,
    _this$__modules__2 = this.__modules__,
    i = _this$__modules__2.slider,
    l = _this$__modules__2.zoomer;
  C(s, {
    transform: `
        translate(var(${Xt}, 0px), var(${Dt}, 0px))
        scale(var(${Yt}, 0))`
  }), H(this.transform, "scale", {
    get: () => this.transform.__scale__,
    set: h => {
      const c = this.useFixedRatio(h);
      if (!(rt(c) || this.transform.__scale__ === c)) {
        if (this.transform.__scale__ = c, C(s, {
          [Yt]: c.toString()
        }), E(this.data.imageData, {
          width: y(s).width,
          height: y(s).height
        }), i) {
          const f = Math.round(this.getScaleRatio() * 100);
          i.value = f;
        }
        if (l && l.options.disabledClass) {
          const f = l.zoomerInEl,
            m = l.zoomerOutEl,
            a = l.zoomerResetEl,
            d = l.options.disabledClass;
          f && (f.classList[c === o ? "add" : "remove"](d), x(f, {
            "aria-disabled": c === o ? "true" : "false"
          })), m && (m.classList[c === n ? "add" : "remove"](d), x(m, {
            "aria-disabled": c === n ? "true" : "false"
          })), a && (a.classList[c === r ? "add" : "remove"](d), x(a, {
            "aria-disabled": c === r ? "true" : "false"
          }));
        }
      }
    }
  }), H(this.transform, "translateX", {
    get: () => this.transform.__translateX__,
    set: h => {
      const c = X(h);
      rt(c) || this.transform.__translateX__ === c || (this.transform.__translateX__ = c, C(s, {
        [Xt]: `${c}px`
      }));
    }
  }), H(this.transform, "translateY", {
    get: () => this.transform.__translateY__,
    set: h => {
      const c = X(h);
      rt(c) || this.transform.__translateY__ === c || (this.transform.__translateY__ = c, C(s, {
        [Dt]: `${c}px`
      }));
    }
  }), b(this, j, Lt).call(this), b(this, q, xt).call(this), E(this.transform, {
    scale: r,
    translateX: 0,
    translateY: 0
  }), t.classList.add(qt), this.mounted = !0, this.emit("ready", this);
}, j = new WeakSet(), Lt = function () {
  const t = this.wrapper,
    s = this.options,
    n = this.controller.signal,
    o = s.draggable,
    r = s.pinchable,
    i = s.wheelable;
  if (this.states = {}, i) {
    this.states.wheeling = !1;
    const l = h => b(this, k, zt).call(this, h);
    t.addEventListener(he, l, {
      signal: n
    });
  }
  if (L && (o || r)) {
    o && (this.states.dragging = !1), r && (this.states.pinching = !1);
    const l = h => b(this, F, Ct).call(this, h);
    t.addEventListener("touchstart", l, {
      signal: n
    });
  }
  if (!L && o) {
    this.states.dragging = !1;
    const l = h => b(this, G, Mt).call(this, h);
    t.addEventListener("mousedown", l, {
      signal: n
    });
  }
  b(this, P, It).call(this);
}, k = new WeakSet(), zt = function (t) {
  const _this$options6 = this.options,
    s = _this$options6.zoomRatio,
    n = _this$options6.wheelReleaseOnMinMax,
    o = _this$options6.disableWheelingClass,
    r = (t.deltaY || t.detail) > 0 ? -1 : 1;
  if (n) {
    const i = this.isOnMinScale(),
      l = this.isOnMaxScale();
    i && r === -1 || l && r === 1 || t.preventDefault();
  } else t.preventDefault();
  this.states.wheeling || ct(t.target, o) || (this.states.wheeling = !0, setTimeout(() => {
    this.states.wheeling = !1;
  }, 30), this.zoom(r * s, R(t)), this.emit("wheel", this, this.transform.scale, t));
}, G = new WeakSet(), Mt = function (t) {
  const s = this.data,
    n = this.transform,
    _this$options7 = this.options,
    o = _this$options7.disableDraggingClass,
    r = _this$options7.smooth,
    i = s.dragData,
    l = s.imageData;
  if (!i || !l) return;
  const h = m => {
      if (m && m.button !== 0 || (m.preventDefault(), ct(m.target, o))) return;
      i.frame !== null && cancelAnimationFrame(i.frame);
      const a = Date.now(),
        _R = R(m),
        d = _R.clientX,
        g = _R.clientY;
      if (E(i, {
        prevX: d,
        prevY: g,
        lastTime: a,
        velocityX: 0,
        velocityY: 0,
        frame: null
      }), this.states.dragging = !0, r) {
        const _ = this.useAnimate(i);
        i.frame = requestAnimationFrame(_);
      }
      this.emit("dragStart", this, {
        x: n.translateX,
        y: n.translateY
      }, m), document.addEventListener("mousemove", c), document.addEventListener("mouseup", f);
    },
    c = m => {
      if (m.touches || !this.states.dragging) return;
      m.preventDefault();
      const a = Date.now(),
        _R2 = R(m),
        d = _R2.clientX,
        g = _R2.clientY,
        _ = d - i.prevX,
        T = g - i.prevY,
        u = a - i.lastTime,
        v = n.translateX + _,
        O = n.translateY + T;
      this.moveTo({
        x: v,
        y: O
      }), r && u > 0 && (i.velocityX = 0.8 * (_ / u) + 0.2 * i.velocityX, i.velocityY = 0.8 * (T / u) + 0.2 * i.velocityY), E(i, {
        prevX: d,
        prevY: g,
        lastTime: a
      }), this.emit("drag", this, {
        x: v,
        y: O
      }, m);
    },
    f = m => {
      m.touches || (this.states.dragging = !1, this.emit("dragEnd", this, {
        x: n.translateX,
        y: n.translateY
      }, m), document.removeEventListener("mousemove", c), document.removeEventListener("mouseup", f));
    };
  h(t);
}, F = new WeakSet(), Ct = function (t) {
  const s = this.data,
    n = this.transform,
    _this$options8 = this.options,
    o = _this$options8.maxScale,
    r = _this$options8.minScale,
    i = _this$options8.draggable,
    l = _this$options8.pinchable,
    h = _this$options8.bounds,
    c = _this$options8.dragReleaseOnBounds,
    f = _this$options8.disableDraggingClass,
    m = _this$options8.smooth,
    a = s.touchData,
    d = s.imageData;
  if (!a || !d) return;
  const g = u => {
      if (!u.touches) return;
      if (h && c) {
        const z = this.isOnBoundX(),
          M = this.isOnBoundY();
        u.touches.length === 1 && (z || M) || u.preventDefault();
      } else u.preventDefault();
      if (ct(u.target, f) && u.touches.length <= 1) return;
      a.frame !== null && cancelAnimationFrame(a.frame);
      const v = Date.now(),
        _y4 = y(this.image),
        O = _y4.top,
        D = _y4.left,
        _this$getImageDiff0 = this.getImageDiff(),
        A = _this$getImageDiff0.width,
        et = _this$getImageDiff0.height,
        _R3 = R(u),
        N = _R3.clientX,
        B = _R3.clientY;
      if (E(a, {
        hypot: Et(u),
        prevX: N,
        prevY: B,
        offsetX: 0,
        offsetY: 0,
        imageTop: O,
        imageLeft: D,
        widthDiff: A,
        heightDiff: et,
        lastTime: v,
        velocityX: 0,
        velocityY: 0,
        frame: null
      }), i) {
        if (this.states.dragging = !0, m) {
          const z = this.useAnimate(a);
          a.frame = requestAnimationFrame(z);
        }
        this.emit("dragStart", this, {
          x: n.translateX,
          y: n.translateY
        }, u);
      }
      l && u.touches.length === 2 && (this.states.pinching = !0, this.emit("pinchStart", this, n.scale, u)), document.addEventListener("touchmove", _), document.addEventListener("touchend", T);
    },
    _ = u => {
      if (!u.touches) return;
      const v = Date.now(),
        _this$states = this.states,
        O = _this$states.dragging,
        D = _this$states.pinching,
        _y5 = y(this.image),
        A = _y5.top,
        et = _y5.left,
        _this$getImageDiff1 = this.getImageDiff(),
        N = _this$getImageDiff1.width,
        B = _this$getImageDiff1.height,
        z = D && u.touches.length !== 2 || !D && u.touches.length === 2,
        M = Et(u),
        st = M ? M / a.hypot : 1,
        nt = this.useFixedRatio(st * n.scale),
        _R4 = R(u),
        it = _R4.clientX,
        ot = _R4.clientY,
        Ht = it + a.offsetX,
        Zt = ot + a.offsetY;
      if (l && u.touches.length === 2 && (D || (this.states.pinching = !0, this.emit("pinchStart", this, n.scale, u)), this.zoomTo(nt, !1)), O) {
        z && (a.velocityX = 0, a.velocityY = 0);
        const pt = nt !== o && nt !== r && l && u.touches.length === 2 ? st : 1,
          Vt = X(Ht - a.imageLeft - (N - a.widthDiff) - (a.prevX - a.imageLeft) * pt + n.translateX),
          Ut = X(Zt - a.imageTop - (B - a.heightDiff) - (a.prevY - a.imageTop) * pt + n.translateY);
        if (this.moveTo({
          x: Vt,
          y: Ut
        }), m && u.touches.length === 1 && !z) {
          const at = v - a.lastTime;
          if (at > 0) {
            const jt = it - a.prevX,
              kt = ot - a.prevY;
            a.velocityX = 0.8 * (jt / at) + 0.2 * a.velocityX, a.velocityY = 0.8 * (kt / at) + 0.2 * a.velocityY;
          }
        }
      }
      E(a, {
        hypot: M,
        prevX: it,
        prevY: ot,
        imageTop: A,
        imageLeft: et,
        widthDiff: N,
        heightDiff: B,
        lastTime: v
      }), D && u.touches.length === 2 && this.emit("pinch", this, n.scale, u), O && this.emit("drag", this, {
        x: n.translateX,
        y: n.translateY
      }, u);
    },
    T = u => {
      if (!u.touches) return;
      const _this$states2 = this.states,
        v = _this$states2.dragging,
        O = _this$states2.pinching;
      if (O && u.touches.length === 1) {
        this.states.pinching = !1;
        const _R5 = R(u),
          D = _R5.clientX,
          A = _R5.clientY;
        E(a, {
          prevX: D,
          prevY: A,
          velocityX: 0,
          velocityY: 0,
          lastTime: Date.now()
        }), this.emit("pinchEnd", this, n.scale, u);
      }
      if (v && !u.touches.length && (this.states.dragging = !1, this.emit("dragEnd", this, {
        x: n.translateX,
        y: n.translateY
      }, u)), v && u.touches.length === 1) {
        const _R6 = R(u),
          D = _R6.clientX,
          A = _R6.clientY;
        E(a, {
          offsetX: a.prevX - D,
          offsetY: a.prevY - A
        });
      }
      u.touches.length || (document.removeEventListener("touchmove", _), document.removeEventListener("touchend", T));
    };
  g(t);
}, P = new WeakSet(), It = function () {
  const t = this.element,
    s = this.image,
    n = this.transform;
  new ResizeObserver(() => {
    const r = t.offsetWidth,
      i = t.offsetHeight,
      _this$getContainerDat2 = this.getContainerData(),
      l = _this$getContainerDat2.width,
      h = _this$getContainerDat2.height;
    if (r === l && i === h) return;
    const c = n.translateX,
      f = n.translateY;
    if (c) {
      const _ = r / l * c;
      this.transform.translateX = _;
    }
    if (f) {
      const _ = i / h * f;
      this.transform.translateY = _;
    }
    const m = s.offsetWidth,
      a = s.offsetHeight,
      _y6 = y(s),
      d = _y6.width,
      g = _y6.height;
    E(this.data.containerData, {
      width: r,
      height: i
    }), E(this.data.imageData, {
      originWidth: m,
      originHeight: a,
      width: d,
      height: g
    }), this.emit("resize", this);
  }).observe(t);
}, q = new WeakSet(), xt = function () {
  const _this$__modules__3 = this.__modules__,
    t = _this$__modules__3.slider,
    s = _this$__modules__3.zoomer;
  t && b(this, K, $t).call(this), s && b(this, Q, Bt).call(this);
}, K = new WeakSet(), $t = function () {
  const t = this.element,
    s = this.__modules__.slider;
  if (!s || s.mounted) return;
  const _s$options = s.options,
    n = _s$options.el,
    o = _s$options.direction;
  if (!n) return;
  const r = n === `.${$}`,
    i = r ? I("div", $) : lt(n);
  if (!i) return;
  const l = I("div", Qt),
    h = I("span", te),
    c = I("span", ee, Object.assign({}, ie, {
      "aria-orientation": o
    }));
  i.classList.add(`${$}-${o}`), H(s, "value", {
    get() {
      return s.__value__;
    },
    set(f) {
      s.__value__ !== f && (s.__value__ = f, C(i, {
        [de]: f.toString()
      }), x(c, {
        "aria-valuenow": f.toString()
      }));
    }
  }), E(s, {
    value: this.getScaleRatio() * 100,
    controller: new AbortController(),
    sliding: !1,
    sliderEl: i,
    sliderTrack: l,
    sliderButton: c
  }), b(this, J, Nt).call(this), l.append(h, c), i.append(l), r && t.append(i), s.mounted = !0;
}, J = new WeakSet(), Nt = function () {
  const _this$options9 = this.options,
    t = _this$options9.minScale,
    s = _this$options9.maxScale,
    n = this.__modules__.slider;
  if (!n) return;
  const o = n.options.direction,
    r = n.controller,
    i = n.sliderEl,
    l = n.sliderTrack;
  if (!i || !l) return;
  const h = o === "vertical",
    c = d => {
      const g = y(l),
        _ = g[h ? "height" : "width"],
        T = g[h ? "bottom" : "left"],
        u = R(d)[h ? "clientY" : "clientX"],
        v = X(w((u - T) * (h ? -1 : 1) / _, 0, 1));
      return (s - t) * v + t;
    },
    f = d => {
      if (d instanceof MouseEvent && d.button !== 0) return;
      n.sliding = !0;
      const g = c(d);
      this.zoomTo(g), this.emit("slideStart", this, this.getSliderValue(), d), document.addEventListener(Tt, m), document.addEventListener(Ot, a);
    },
    m = d => {
      if (!n.sliding) return;
      const g = c(d);
      this.zoomTo(g), this.emit("slide", this, this.getSliderValue(), d);
    },
    a = d => {
      this.emit("slideEnd", this, this.getSliderValue(), d), n.sliding = !1, document.removeEventListener(Tt, m), document.removeEventListener(Ot, a);
    };
  i.addEventListener(ce, f, {
    signal: r == null ? void 0 : r.signal
  });
}, Q = new WeakSet(), Bt = function () {
  const t = this.element,
    s = this.__modules__.zoomer;
  if (!s || s.mounted) return;
  const _s$options2 = s.options,
    n = _s$options2.el,
    o = _s$options2.inEl,
    r = _s$options2.outEl,
    i = _s$options2.resetEl,
    l = [o, r, i],
    h = (d, g, _, T, u) => {
      if (!d) return null;
      const v = d === `.${_}`;
      return _ = l.includes(d) ? `${_} ${se}` : _, v ? I(g, _, T, u) : lt(d);
    },
    c = h(n, "div", Z),
    f = h(o, "button", mt, oe, Se),
    m = h(r, "button", dt, ae, be),
    a = h(i, "button", ft, re, Te);
  E(s, {
    controller: new AbortController(),
    zoomerEl: c,
    zoomerInEl: f,
    zoomerOutEl: m,
    zoomerResetEl: a
  }), c && (f && c.append(f), m && c.append(m), a && c.append(a), n === `.${Z}` && t.append(c)), b(this, tt, Wt).call(this), s.mounted = !0;
}, tt = new WeakSet(), Wt = function () {
  const t = this.options.zoomRatio,
    s = this.__modules__.zoomer,
    n = this;
  if (!s) return;
  const o = s.controller,
    r = s.zoomerInEl,
    i = s.zoomerOutEl,
    l = s.zoomerResetEl;
  r && r.addEventListener("click", () => {
    n.zoom(t);
  }, {
    signal: o == null ? void 0 : o.signal
  }), i && i.addEventListener("click", () => {
    n.zoom(-t);
  }, {
    signal: o == null ? void 0 : o.signal
  }), l && l.addEventListener("click", () => {
    n.reset();
  }, {
    signal: o == null ? void 0 : o.signal
  });
};
Object.assign(Ye.prototype, Oe);
export { Ye as default };